import * as angular from 'angular';

class UploadFileController implements angular.IController {
  static $inject = ['$element'];

  FILENAME_SELECTOR = '#upload-filename';
  CERT_SELECTOR = '#data_source_certificate';

  constructor(private $element: angular.IRootElementService) {}

  $postLink() {
    const $filenameElem = this.$element.find(this.FILENAME_SELECTOR);
    const $certElem = this.$element.find(this.CERT_SELECTOR);

    if (!$filenameElem[0] || !$certElem[0]) {
      console.warn('could not find correct DOM elements for upload-file-component');
    }
    $filenameElem.html('No file chosen');

    $certElem.change((evt) => {
      let filename = $(evt.target).val() || 'No file chosen';
      const lastIndex = filename.lastIndexOf('\\');

      if (lastIndex >= 0) {
        filename = filename.substring(lastIndex + 1);
      }
      filename = filename || 'No file chosen';
      $filenameElem.html(filename);
    });
  }

  $onDestroy() {
    const $certElem = this.$element.find(this.CERT_SELECTOR);
    $certElem.off('change');
  }
}

const UploadFileComponent: angular.IComponentOptions = {
  bindings: {},
  controller: UploadFileController,
  controllerAs: 'ctrl',
  transclude: true,
  template: `
  <span class="upload-btn-wrapper input-group">
    <div class="form-control mode-input" id="upload-filename"></div>
    <div class="upload-btn-group">
      <capra-button
        text="Choose file"
      >
      </capra-button>
      <ng-transclude></ng-transclude>
    </div>
  </span>
  `,
};

export { UploadFileComponent };
angular.module('mode.components').component('uploadFile', UploadFileComponent);
